// extracted by mini-css-extract-plugin
export var container = "SupplementaryDataSubForm-module__container___uead5";
export var contentRow = "SupplementaryDataSubForm-module__contentRow___A44RE";
export var dynamicContainer = "SupplementaryDataSubForm-module__dynamicContainer___CHGGy";
export var field = "SupplementaryDataSubForm-module__field___nr+nv";
export var large = "1084px";
export var medium = "860px";
export var small = "540px";